import { domReady } from './Functions/DomReady';
import { MainMenuController } from './Controllers/MainMenuController';
import { AccordionController } from './Controllers/AccordionController';
import { NewsController } from './Controllers/NewsController';
import { checkBreadcrumbsPosition } from './Functions/BreadcrubsPosition';
import {reduceGridPadding} from './Functions/ReduceGridPadding';
import {TextMediaButtonController} from './Controllers/TextMediaButtonController';

domReady(() => {
  new MainMenuController();
  new AccordionController();
  new NewsController();
  new TextMediaButtonController();
  checkBreadcrumbsPosition();
  reduceGridPadding();

  if (document.getElementsByClassName('js-slider').length) {
    import(/* webpackChunkName: "Slider" */ './Controllers/SliderController').then(module => {
      new module.SliderController();
    });
  }
});
